
// imported in base router.ts
export default
	[
		{
			path: "/websiteconfiguration/:id/search/",
			name: "searchconfiguration",
			component: () => import("@/Views/Domain/ViewerConfiguration/SearchConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "Search Configuration", page: "website" }
		},
		{
			path: "/websiteconfiguration/:id/template/",
			name: "templateconfiguration",
			component: () => import("@/Views/Domain/ViewerConfiguration/TemplateConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "Template Configuration", page: "website" }
		},
		{
			path: "/websiteconfiguration/:id/toc/",
			name: "tocconfiguration",
			component: () => import("@/Views/Domain/ViewerConfiguration/TOCConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "Table of Contents configuration", page: "website" }
		}, {
			path: "/websiteconfiguration/:id/",
			name: "websiteconfiguration",
			component: () => import("@/Views/Domain/ViewerConfiguration/ViewerConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "Website Configuration", page: "website" }
		},
	];
